<template>
  <light :is-switched-on="isSwitchOn" :switch-on-color="getColor" class="w-100" />
</template>

<script>
import config from '@/config';
import SwitchMixin from '@/components/icons/mixins/Switch';
import RGBMixin from '@/components/utils/mixins/RGB';

export default {
  name: 'LightWrapper',
  mixins: [
    SwitchMixin,
    RGBMixin,
  ],
  data() {
    return {
      switchedOnColor: '#FFED00',
    };
  },
  computed: {
    getColor() {
      const RGBColor = this.getRGBColor();
      if (RGBColor) {
        return RGBColor;
      }
      return this.switchedOnColor;
    },
    isSwitchOn() {
      const vars = this.getVarsByActorsArgumentName('LIGHT_OUT');
      if (vars.length > 0) {
        return vars[0].value;
      }
      return false;
    },
  },
  methods: {
    getRGBColor() {
      const vars = this.getVarsByActorsRole(config.ICOOL.ACTORS_ROLES.RGB);
      if (vars && vars.length === 3) {
        return this.RGB2Hex(vars);
      }
      return null;
    },
  },
};
</script>

<style scoped>

</style>
